module.exports = __webpack_public_path__ + "static/cekilis-e5f678a1644c69049764ae6d367d6977.svg";